import logo from '@/assets/img/logo_opacity.svg';
import config from '@/config'; // eslint-disable-line import/extensions

const lazyWidgetPageComponent = () => import('@/Pages/Widget/index.vue');

export const widgetRoute = {
  path: '/widget',
  pathname: '/widget',
  name: 'Widget page',
  component: lazyWidgetPageComponent,
  props: {
    locale: 'ru',
    logoUrl: logo,
    logoLinkUrl: config.widget.logoUrl,
  },
  meta: {
    name: 'Виджет',
  },
};

export const widgetEnRoute = {
  path: '/widget/en',
  pathname: '/widget/en',
  name: 'Widget page en',
  component: lazyWidgetPageComponent,
  props: {
    locale: 'en',
    logoUrl: logo,
    logoLinkUrl: config.widget.logoUrlEn,
  },
  meta: {
    name: 'Widget',
  },
};

export const panoramaRoute = {
  path: '/widget/panorama',
  pathname: '/widget/panorama',
  name: 'Widget panorama page',
  component: lazyWidgetPageComponent,
  props: {
    tabs: ['panorama'],
  },
  meta: {
    name: 'Панорамный тур',
  },
};

export const panoramaEnRoute = {
  path: '/widget/en/panorama',
  pathname: '/widget/en/panorama',
  name: 'Widget panorama page en',
  component: lazyWidgetPageComponent,
  props: {
    locale: 'en',
    logoUrl: logo,
    logoLinkUrl: config.widget.logoUrlEn,
    tabs: ['panorama'],
  },
  meta: {
    name: 'Panoramic tour',
  },
};
